module.exports = __webpack_public_path__ + "img/cs-contactUs-1.45b486ee.jpg";